import { useEffect, useState } from 'react';
import { useRouteError } from 'react-router-dom';

const AppErrorBoundary = () => {
  const [copied, setCopied] = useState(false);
  const error = useRouteError() as object;

  const getMessage = () => {
    if ('message' in error) {
      return error.message;
    }

    return error;
  };

  const message = String(getMessage());

  const handleClick = () => {
    setCopied(true);

    void navigator.clipboard.writeText(message);
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  return <div className="flex h-full items-center justify-center"></div>;
};

export default AppErrorBoundary;